import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  private data: any = undefined;

  public setData(data: any) {
    this.data = data;
  }

  public getData() {
    return this.data;
  }

  public clearData() {
    this.data = undefined;
  }
}
